import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { setTitle } from 'store/reducer/appReducer';

const Dashboard: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTitle("Dashboard"));
  }, [dispatch]);

  const getCurrentTime = () => {
    return new Date().toLocaleString('th-TH', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Box sx={{ p: 4 }}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={8} lg={6}>
          <Card elevation={2} sx={{ textAlign: 'center', borderRadius: 3 }}>
            <CardContent sx={{ p: 5 }}>
              <Typography variant="h3" component="h1" fontWeight="600" color="primary" gutterBottom>
                🎉 ยินดีต้อนรับ
              </Typography>
              
              <Typography variant="h5" color="text.secondary" gutterBottom sx={{ mt: 2, mb: 3 }}>
                สู่ระบบจัดการเว็บไซต์
              </Typography>

              <Paper 
                elevation={1} 
                sx={{ 
                  p: 3, 
                  bgcolor: 'grey.50', 
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'grey.200'
                }}
              >
                <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
                  สวัสดี <strong>ผู้ดูแลระบบ</strong>
                </Typography>
                
                <Typography variant="body2" color="text.secondary">
                  📅 {getCurrentTime()}
                </Typography>
              </Paper>

              <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.6 }}>
                คุณสามารถใช้เมนูด้านซ้ายเพื่อจัดการข้อมูลต่างๆ ในระบบได้
              </Typography>
              
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: 'italic' }}>
                Central Metals (Thailand) Ltd.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
